import React from 'react';
import CBSwitch from '../shared/form_components/CBSwitch';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle } from '../../utils/utils';
import { styles, tagStyle } from './notificationSettingsStyles';

// One labelled on/off switch. `badge` shows a small tag after the label and
// `action` renders a text button (e.g. "Palauta") before the switch.
const NotificationToggleRow = ({
  label, hint, badge, checked, onChange, disabled, action, first, master, testId,
}) => (
  <CBMediaQuery>
    {screenSize => (
      <div
        data-testid={testId}
        style={master
          ? getStyle(screenSize, styles, 'masterRow')
          : {
            ...getStyle(screenSize, styles, 'row'),
            ...(first ? styles.default.firstRow : {}),
          }}
      >
        <div style={getStyle(screenSize, styles, 'rowText')}>
          <p style={getStyle(screenSize, styles, 'rowLabel')}>
            <span>{label}</span>
            {badge && <span style={tagStyle('active')}>{badge}</span>}
          </p>
          {hint && <p style={getStyle(screenSize, styles, 'rowHint')}>{hint}</p>}
        </div>
        <div style={getStyle(screenSize, styles, 'rowControls')}>
          {action && (
            <button type='button' style={styles.default.linkButton} onClick={action.onClick} disabled={disabled}>
              {action.label}
            </button>
          )}
          <CBSwitch
            size='small'
            checked={!!checked}
            disabled={disabled}
            onChange={onChange}
          />
        </div>
      </div>
    )}
  </CBMediaQuery>
);

export default NotificationToggleRow;
